import App from 'app/app.js';

// This is a constants object to use for handling mapping to the property used to traverse
// to the unique id of objects cached in array.
var CacheConstants = {
  jobDataOptions: {
    propertyMap: ['jobContext', 'jobKey'],
    isArray: true
  },
  jobDataJobContextImageAuthorizationOptions: {
    propertyMap: ['jobContext', 'imageAuthorizations'],
    isArray: true
  }
};

App.constant('CacheConstants', CacheConstants);
